import { Text } from './base/Text';
import { Row } from './layout/Row';

const VARIANTS = {
  LIGHT: {
    ERROR: {
      STYLE: {
        BUTTON:
          'bg-errorBG text-errorText dark:bg-errorBG-dark dark:text-errorText-dark',
        DOT: 'bg-errorText dark:bg-errorText-dark',
      },
      MSG: 'Élevé',
    },
    WARNING: {
      STYLE: {
        BUTTON:
          'bg-warningBG text-warningText dark:bg-warningBG-dark dark:text-warningText-dark',
        DOT: 'bg-warningText dark:bg-warningText-dark',
      },
      MSG: 'Moyen',
    },
    SUCCESS: {
      STYLE: {
        BUTTON:
          'bg-successBG text-successText dark:bg-successBG-dark dark:text-successText-dark',
        DOT: 'bg-successText dark:bg-successText-dark',
      },
      MSG: 'Faible',
    },
    TRUST: {
      STYLE: {
        BUTTON:
          'bg-successBG text-successText dark:bg-successBG-dark dark:text-successText-dark',
        DOT: 'bg-successText dark:bg-successText-dark',
      },
      MSG: 'Nul',
    },
  },
  FILLED: {
    ERROR: {
      STYLE: {
        BUTTON:
          'bg-errorText text-white dark:bg-errorText-dark dark:text-white-dark',
        DOT: 'bg-white',
      },
      MSG: 'Élevé',
    },
    WARNING: {
      STYLE: {
        BUTTON:
          'bg-warningText text-white dark:bg-warningText-dark dark:text-white-dark',
        DOT: 'bg-white',
      },
      MSG: 'Moyen',
    },
    SUCCESS: {
      STYLE: {
        BUTTON:
          'bg-successText text-white dark:bg-successText-dark dark:text-white-dark',
        DOT: 'bg-white',
      },
      MSG: 'Faible',
    },
    TRUST: {
      STYLE: {
        BUTTON:
          'bg-successText text-white dark:bg-successText-dark dark:text-white-dark',
        DOT: 'bg-white',
      },
      MSG: 'Nul',
    },
  },
};

let riskStatusStyleButton: string;
let RiskStatusStyleDot: string;
let riskStatusMessage: string;

export const RiskStatus = ({
  risk,
  type = 'FILLED',
}: {
  risk: number;
  type?: keyof typeof VARIANTS;
}) => {
  switch (risk) {
    case -1:
      riskStatusStyleButton = VARIANTS[type].TRUST.STYLE.BUTTON;
      RiskStatusStyleDot = VARIANTS[type].TRUST.STYLE.DOT;
      riskStatusMessage = VARIANTS[type].TRUST.MSG;
      break;
    case 0:
      riskStatusStyleButton = VARIANTS[type].SUCCESS.STYLE.BUTTON;
      RiskStatusStyleDot = VARIANTS[type].SUCCESS.STYLE.DOT;
      riskStatusMessage = VARIANTS[type].SUCCESS.MSG;
      break;
    case 1:
      riskStatusStyleButton = VARIANTS[type].SUCCESS.STYLE.BUTTON;
      RiskStatusStyleDot = VARIANTS[type].SUCCESS.STYLE.DOT;
      riskStatusMessage = VARIANTS[type].SUCCESS.MSG;
      break;
    case 2:
      riskStatusStyleButton = VARIANTS[type].WARNING.STYLE.BUTTON;
      RiskStatusStyleDot = VARIANTS[type].WARNING.STYLE.DOT;
      riskStatusMessage = VARIANTS[type].WARNING.MSG;
      break;
    case 3:
      riskStatusStyleButton = VARIANTS[type].ERROR.STYLE.BUTTON;
      RiskStatusStyleDot = VARIANTS[type].ERROR.STYLE.DOT;
      riskStatusMessage = VARIANTS[type].ERROR.MSG;
      break;
    default:
      break;
  }
  return (
    <Row
      className={`flex justify-center px-2 py-1 ${riskStatusStyleButton} ${type === 'FILLED' ? 'rounded-md uppercase' : 'rounded-full'}`}
      gap="xxs"
      width="fit"
    >
      <span
        className={
          RiskStatusStyleDot + ' mr-1 inline-flex h-[7px] w-[7px] rounded-full'
        }
      ></span>
      <Text size="xs" className="!text-inherit">
        {riskStatusMessage}
      </Text>
    </Row>
  );
};
